import './ActivityResultStates.scss';

import * as React from 'react';

import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { Stack } from '~shared/components/Stack';

import { ActivityResultStateIcon } from './ActivityResultStateIcon';

export const ActivityResultError = () => {
  return (
    <div className="activity-result-states-container flex flex-col justify-center items-center">
      <ActivityResultStateIcon />
      <div className="px-8 pt-12 max-w-3xl">
        <Stack space="8" align="center">
          <span className="font-display text-md font-500 text-blue-900">
            {translate('Something Went Wrong')}
          </span>
          <p className="font-sans text-base leading-8 text-blue-900 text-center">
            {translate('Please try again or contact support for assistance.')}
          </p>
          <UIButton
            onClick={() => {
              window.location.reload();
            }}
          >
            {translate('Reload')}
          </UIButton>
        </Stack>
      </div>
    </div>
  );
};
